module.exports = __webpack_public_path__ + "static/media/logo-mystar.2f53be3c.svg";